import React, { useEffect, useState } from "react";
import AddUser from "./operations/AddUser";
import AddCustomerCareUser from "../CustomerCare/AddCustomerCareUser";

const AddUserHome = () => {
  const [selectedSegment, setSelectedSegment] = useState("");

  useEffect(() => {
    setSelectedSegment(() => localStorage.getItem("userRole"));
  }, []);
  return selectedSegment === "Operations" ||
    selectedSegment === "Admin Operations" ? (
    <AddUser />
  ) : selectedSegment === "Renewal" || selectedSegment === "Admin Renewal" ? (
    <AddUser />
  ) : selectedSegment === "Customer Care" ||
    selectedSegment === "Admin Customer Care" ? (
    <AddCustomerCareUser />
  ) : (
    <h1>page Not fOUND</h1>
  );
};

export default AddUserHome;
